import { createTheme, alpha } from '@mui/material/styles';
import { red, grey } from '@mui/material/colors';

const sharedTypography = {
  fontFamily: [
    'Roboto',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Arial',
    'sans-serif',
  ].join(','),
  h1: { fontWeight: 600 },
  h2: { fontWeight: 600 },
  h3: { fontWeight: 600 },
  h4: { fontWeight: 600 },
  h5: { fontWeight: 500 },
  h6: { fontWeight: 500 },
  button: { textTransform: 'none' as const, fontWeight: 500 },
};

export function getTheme(mode: 'dark' | 'light') {
  const isDark = mode === 'dark';
  const dividerBase = isDark ? '#fff' : '#000';
  const appBg = isDark ? '#141416' : '#ffffff';
  const drawerBg = isDark ? '#141416' : '#fafafa';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: red[600],
        light: red[400],
        dark: red[800],
        contrastText: '#fff',
      },
      secondary: {
        main: isDark ? grey[500] : grey[600],
      },
      background: {
        default: isDark ? '#0f0f10' : '#f5f5f7',
        paper: isDark ? '#1a1a1c' : '#ffffff',
      },
      divider: alpha(dividerBase, 0.08),
      text: {
        primary: isDark ? '#f5f5f5' : 'rgba(0,0,0,0.87)',
        secondary: isDark ? grey[400] : grey[700],
      },
      success: { main: '#4caf50' },
      warning: { main: isDark ? '#ff9800' : '#e65100' },
      error: { main: '#f44336' },
      info: { main: isDark ? '#29b6f6' : '#0288d1' },
    },
    shape: { borderRadius: 10 },
    typography: sharedTypography,
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            transition: 'background-color 200ms ease, color 200ms ease',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            backgroundColor: appBg,
            borderBottom: `1px solid ${alpha(dividerBase, 0.08)}`,
            transition: 'background-color 200ms ease',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundImage: 'none',
            backgroundColor: drawerBg,
            borderRight: `1px solid ${alpha(dividerBase, 0.08)}`,
            transition: 'background-color 200ms ease',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: { backgroundImage: 'none' },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            marginInline: 8,
            '&.Mui-selected': {
              backgroundColor: alpha(red[600], 0.15),
              '&:hover': { backgroundColor: alpha(red[600], 0.22) },
              '& .MuiListItemIcon-root': { color: red[400] },
            },
          },
        },
      },
    },
  });
}

export const theme = getTheme('dark');
